import { render, staticRenderFns } from "./SettingTextView.vue?vue&type=template&id=312ad02c&scoped=true&"
import script from "./SettingTextView.vue?vue&type=script&lang=js&"
export * from "./SettingTextView.vue?vue&type=script&lang=js&"
import style0 from "./SettingTextView.vue?vue&type=style&index=0&id=312ad02c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312ad02c",
  null
  
)

export default component.exports